import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

interface PopularSectionProps {
  id?: string;
  title: string;
  subtitle: string;
  comicsSlice: typeof comics;
}

export default function PopularSection({ id, title, subtitle, comicsSlice }: PopularSectionProps) {
  return (
    <section id={id} className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              {title}
            </h2>
            <p className="text-sm text-foreground-500 mt-2">{subtitle}</p>
          </div>
          <Link
            to="/category/action"
            className="text-sm text-accent-500 hover:text-accent-600 transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
          {comicsSlice.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}